import { Injectable } from '@angular/core';

export interface StorePreset {
  id: string;
  name: string;
  selectedArea: any[];
  selectedPref?: any[];
  selectedStores: any[];
  createdAt: number;
}

const MAX_PRESETS = 5;

@Injectable({
  providedIn: 'root',
})
export class StorePresetService {
  private getStorageKey(componentName: string): string {
    return `presets_${componentName}`;
  }

  getPresets(componentName: string): StorePreset[] {
    const raw = localStorage.getItem(this.getStorageKey(componentName));
    if (!raw) return [];
    return JSON.parse(raw) as StorePreset[];
  }

  canSaveMore(componentName: string): boolean {
    return this.getPresets(componentName).length < MAX_PRESETS;
  }

  savePreset(
    componentName: string,
    data: { name: string; selectedArea: any[]; selectedPref?: any[]; selectedStores: any[] },
  ): StorePreset | null {
    const presets = this.getPresets(componentName);
    if (presets.length >= MAX_PRESETS) return null;

    const preset: StorePreset = {
      id: crypto.randomUUID(),
      name: data.name,
      selectedArea: data.selectedArea,
      selectedPref: data.selectedPref,
      selectedStores: data.selectedStores,
      createdAt: Date.now(),
    };
    presets.push(preset);
    localStorage.setItem(this.getStorageKey(componentName), JSON.stringify(presets));
    return preset;
  }

  deletePreset(componentName: string, presetId: string): void {
    const presets = this.getPresets(componentName).filter((p) => p.id !== presetId);
    localStorage.setItem(this.getStorageKey(componentName), JSON.stringify(presets));
  }

  loadPreset(componentName: string, presetId: string): StorePreset | null {
    return this.getPresets(componentName).find((p) => p.id === presetId) || null;
  }
}
